<template>
  <div>
    <h2>CohortSubpage</h2>
  </div>
</template>

<script>
export default {
  name: "CohortSubpage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
